export default __webpack_public_path__ + "static/media/eyes.dbfc3f87.svg";